import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { DepartamentType } from "../../../types/Departament";

const initialState: DepartamentType = {
    description: "",
    idFaculty: "",
    faculty: "",
    province: ""
};
export const departamentSlice = createSlice({
    name: "departamentForm",
    initialState,
    reducers: {
        setUpdateDepartamentData: (
            state, action: PayloadAction<DepartamentType>,
        ) => {
            return { ...state, ...action.payload };
        },
        resetUpdateDepartamentData: (
            state,
        ) => {
            return initialState
        }
    }
});
export const { setUpdateDepartamentData,resetUpdateDepartamentData } = departamentSlice.actions;
export default departamentSlice.reducer;